







import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({ components: {} })
export default class SortTh extends Vue {
  @Prop({ required: true })
  private title!: string;
  @Prop({ default: '' })
  private target!: string;
  @Prop({ default: 80 })
  private width!: number;

  private up: boolean | null = null;

  sort() {
    this.up = !this.up;

    this.$emit('click', this.up, this.target);
  }
}
